import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import parseUrl from 'url-parse';
import { useAudioPlayer } from '@lwtears/lwt-common-frontend/lib/AudioManager';

import { setModule, loadCommonAssets } from 'store/actions/ui';
import { resetProgress } from 'store/actions/student';
import { t } from '../../../translations';

import Header from './Header';
import AppCard from './AppCard';
import selectionStyle from '../style/AppSelection.module.scss';
import Loading from '../../../components/Loading';
import withRouter from '../../../hooks/withRouter';
import { getSessionId } from '@lwtears/lwt-common-frontend/lib/@common';
import { useLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';

const { REACT_APP_S3_PREFIX, REACT_APP_WDT_REDIRECT } = process.env;

const AppSelection = ({ resetProgress, router, setModule, loadCommonAssets, modules, loading }) => {
  const [
    {
      settings: {
        accessibility: {
          displaySettings: { contentScaling }
        }
      }
    }
  ] = useLwtStore();

  const [, { play }] = useAudioPlayer();

  const [header, setHeader] = useState('');

  const onLicenseSelect = async ({ module, audio = {} }) => {
    if (module.disabled) return;

    const processLicenseSelection = () => {
      if (module === 'wdt') {
        const parsed = parseUrl(REACT_APP_WDT_REDIRECT, true);
        parsed.set('query', {
          ...parsed.query,
          session: getSessionId()
        });
        window.location.href = parsed.toString();
      } else {
        setModule(module);
        router.navigate(`/${module}/splash`);
      }
    };

    if (audio.src) {
      play({ src: audio.src, onend: processLicenseSelection });
    } else {
      processLicenseSelection();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setHeader(t('AppSelectionHeader'));
    }, 100);
  }, []);

  useEffect(() => {
    document.title = `${t('AppSelection')}`;
    setModule('app-selection');
    loadCommonAssets();
    resetProgress();
  }, [loadCommonAssets, resetProgress, setModule]);

  useEffect(() => {
    play(`${REACT_APP_S3_PREFIX}/audio/choose-an-application.mp3`);
  }, []);

  if (!modules) return null;

  const wdt = modules?.find(m => m.module === 'wdt');
  const letters = modules?.find(m => m.module === 'letters');
  const numbers = modules?.find(m => m.module === 'numbers');

  const appCardsDetails = [
    { id: 'wet-dry-try-app', appType: wdt, headerTitle: t('WDT') },
    { id: 'letters-app', appType: letters, headerTitle: t('SoundAroundLetters') },
    { id: 'numbers-app', appType: numbers, headerTitle: t('T&F') }
  ];

  if (loading) {
    return <Loading />;
  }
  return (
    <div className={'componentWrapper'}>
      <div className={selectionStyle.loginPage}>
        <Header />
        <div
          className={[
            selectionStyle.loginSelection,
            selectionStyle[`loginSelection${contentScaling}`]
          ].join(' ')}
          id="choose-application"
        >
          <h1
            className={[
              selectionStyle.appSelectionHeader,
              selectionStyle[`appSelectionHeader${contentScaling}`]
            ].join(' ')}
          >
            {header}
          </h1>
          <div
            className={[selectionStyle.appCards, selectionStyle[`appCards${contentScaling}`]].join(
              ' '
            )}
          >
            {appCardsDetails.map(appCardDetails => (
              <AppCard
                key={appCardDetails.id}
                {...appCardDetails}
                onLicenseSelect={onLicenseSelect}
                selectionStyle={selectionStyle}
                contentScaling={contentScaling}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

AppSelection.propTypes = {
  match: PropTypes.object,
  loading: PropTypes.bool,
  modules: PropTypes.array,
  setModule: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  resetProgress: PropTypes.func.isRequired,
  loadCommonAssets: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  loading: state.ui.loading,
  modules: state.login.modules
});

export default connect(mapStateToProps, {
  setModule,
  resetProgress,
  loadCommonAssets
})(withRouter(AppSelection));
